import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';

@Injectable()
export class DistributorSettingsResolver implements Resolve<boolean | null | RedirectCommand> {
  async resolve(): Promise<boolean | null> {
    return true;
  }
}
